import FormikField from './FormikField'
import { formatDateInSelectedFormat } from '../../../services/util/formatter'

const DatePicker = ({
  field,
  form: { touched, errors },
  ...props
}) => {
  field.value = formatDateInSelectedFormat(field.value, 'YYYY-MM-DD')

  return <input type={'date'} {...field} {...props} />
}

const DateField = ({ name, className, ...props }) => {
  return (
    <FormikField
      name={name}
      component={DatePicker}
      className={className}
      {...props}
    />
  )
}

export default DateField
